module.exports = __webpack_public_path__ + "static/img/7.5d80308.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/2/zh/7.png
// module id = tbYF
// module chunks = 0